import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import InfoWindow from '../InfoWindow';

const SidebarViewPropTypes = {
  children: PropTypes.node, // Child components and elements passed to Sidebar
  toggle: PropTypes.bool.isRequired, // The current state of the vehicle selector component (open/closed)
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If directions have successfully returned from service
};

const SidebarViewDefaultProps = {
  children: null,
};

// eslint-disable-next-line arrow-parens
const SidebarView = props => {
  // eslint-disable-next-line object-curly-newline
  const { toggle, isMobile, directionsLoaded, children } = props;

  return (
    <div
      className={classNames('sidebar', {
        'slide-out': (toggle && isMobile) || (directionsLoaded && isMobile),
        'slide-in': !toggle && isMobile,
      })}
    >
      <div className="sidebar__wrapper">
        <div className="sidebar__container">{children}</div>
      </div>
      <InfoWindow />
    </div>
  );
};

SidebarView.propTypes = SidebarViewPropTypes;

SidebarView.defaultProps = SidebarViewDefaultProps;

export default SidebarView;
